enum UserRoleTypeEnum {
  ADMIN = "ADMIN",
  USER = "USER",
  VIEWER = "VIEWER",
}

export default UserRoleTypeEnum;
